(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vcc-signal-desk"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-vcc-signal-desk]';

    const initialize = (root) => {
      if (!(root instanceof HTMLElement) || root.dataset.vccSignalReady === 'true') return;

      const configNode = root.querySelector('[data-vcc-signal-config]');
      if (!configNode) return;

      let config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (_error) {
        return;
      }

      root.dataset.vccSignalReady = 'true';

      const cleanupTasks = [];
      const listen = (target, eventName, handler, options) => {
        if (!target) return;
        target.addEventListener(eventName, handler, options);
        cleanupTasks.push(() => target.removeEventListener(eventName, handler, options));
      };

      const topicButtons = Array.from(root.querySelectorAll('[data-vcc-topic]'));
      const topicInput = root.querySelector('[data-vcc-topic-input]');
      const contactForm = root.querySelector('.vcc-signal-desk__form');
      const nameInput = root.querySelector('[name="contact[name]"]');
      const emailInput = root.querySelector('[name="contact[email]"]');
      const phoneInput = root.querySelector('[name="contact[phone]"]');
      const message = root.querySelector('[data-vcc-message]');
      const referenceInput = root.querySelector('[data-vcc-reference-input]');
      const signalText = root.querySelector('[data-vcc-signal-text]');
      const signalBars = Array.from(root.querySelectorAll('.vcc-signal-desk__signal-bar'));
      const selectedCard = root.querySelector('[data-vcc-selected-product]');
      const selectedThumb = root.querySelector('[data-vcc-selected-thumb]');
      const selectedTitle = root.querySelector('[data-vcc-selected-title]');
      const selectedMeta = root.querySelector('[data-vcc-selected-meta]');
      const selectedLink = root.querySelector('[data-vcc-selected-link]');
      const changeProduct = root.querySelector('[data-vcc-change-product]');
      const removeProduct = root.querySelector('[data-vcc-remove-product]');
      const finder = root.querySelector('[data-vcc-product-finder]');
      const finderState = root.querySelector('[data-vcc-finder-state]');
      const searchInput = root.querySelector('[data-vcc-product-search]');
      const searchReset = root.querySelector('[data-vcc-product-search-reset]');
      const searchStatus = root.querySelector('[data-vcc-product-search-status]');
      const searchResults = root.querySelector('[data-vcc-product-search-results]');
      const feedback = root.querySelector('[data-vcc-form-feedback][autofocus]');
      const fields = {
        title: root.querySelector('[data-vcc-product-title-field]'),
        sku: root.querySelector('[data-vcc-product-sku-field]'),
        url: root.querySelector('[data-vcc-product-url-field]'),
        handle: root.querySelector('[data-vcc-product-handle-field]'),
        productId: root.querySelector('[data-vcc-product-id-field]'),
        variantId: root.querySelector('[data-vcc-variant-id-field]'),
        source: root.querySelector('[data-vcc-product-source-field]')
      };

      const normalizeTopic = (value) => String(value || '')
        .trim()
        .toLocaleLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

      let topicTouched = false;
      const setTopic = (requestedValue, options = {}) => {
        const normalized = normalizeTopic(requestedValue);
        const selected = topicButtons.find((button) => {
          return normalizeTopic(button.dataset.topicKey) === normalized
            || normalizeTopic(button.dataset.topicLabel) === normalized;
        });

        if (!selected) return false;

        topicButtons.forEach((button) => {
          button.setAttribute('aria-pressed', button === selected ? 'true' : 'false');
        });

        if (topicInput) topicInput.value = selected.dataset.topicLabel || selected.textContent.trim();
        if (message) message.placeholder = selected.dataset.topicPlaceholder || message.placeholder;
        if (options.markTouched !== false) topicTouched = true;
        return true;
      };

      topicButtons.forEach((button) => {
        listen(button, 'click', () => setTopic(button.dataset.topicKey || button.dataset.topicLabel));
      });

      const signalLabels = Array.isArray(config.strings && config.strings.signal)
        ? config.strings.signal
        : ['No signal', 'Signal detected', 'Good start', 'Useful details', 'Clear message', 'Well documented', 'Ready to send'];
      let currentSignalLevel = -1;

      const hasInputValue = (input) => Boolean(input && input.value.trim());
      const hasProductAttachment = () => Object.values(fields).some(hasInputValue);

      const signalLevel = () => {
        const messageLength = message ? message.value.trim().length : 0;
        const hasValidEmail = hasInputValue(emailInput) && emailInput.validity.valid;
        const hasOptionalDetail = hasInputValue(phoneInput)
          || hasInputValue(referenceInput)
          || hasProductAttachment();

        const score = [
          hasInputValue(nameInput),
          hasValidEmail,
          hasOptionalDetail,
          messageLength >= 10,
          messageLength >= 30,
          messageLength >= 80,
          messageLength >= 120
        ].filter(Boolean).length;

        const maximumLevel = hasValidEmail ? 6 : 5;
        return Math.min(maximumLevel, score);
      };

      const updateSignal = () => {
        const level = signalLevel();
        root.classList.toggle('is-signal-ready', level === 6);
        signalBars.forEach((bar, index) => bar.classList.toggle('is-active', index < level));
        if (level !== currentSignalLevel) {
          currentSignalLevel = level;
          if (signalText) signalText.textContent = signalLabels[level] || signalLabels[0] || '';
        }
      };

      [nameInput, emailInput, phoneInput, referenceInput, message].forEach((input) => {
        listen(input, 'input', updateSignal);
        listen(input, 'change', updateSignal);
      });
      listen(contactForm, 'reset', () => window.requestAnimationFrame(updateSignal));
      listen(window, 'pageshow', updateSignal);
      updateSignal();

      const cleanText = (value, maximumLength) => {
        return String(value || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, maximumLength);
      };

      const cleanId = (value) => {
        const candidate = cleanText(value, 30);
        return /^\d+$/.test(candidate) ? candidate : '';
      };

      const cleanHandle = (value) => {
        const candidate = cleanText(value, 255).toLocaleLowerCase();
        return /^[a-z0-9][a-z0-9-]*$/.test(candidate) ? candidate : '';
      };

      const hostFromUrl = (value) => {
        try {
          return new URL(value).hostname.toLocaleLowerCase();
        } catch (_error) {
          return '';
        }
      };

      const allowedProductHosts = new Set([
        window.location.hostname,
        cleanText(config.shopDomain, 255),
        cleanText(config.permanentDomain, 255),
        hostFromUrl(config.shopUrl)
      ].filter(Boolean).map((host) => host.toLocaleLowerCase()));

      const buildCanonicalProductUrl = (handleValue, variantValue = '') => {
        const handle = cleanHandle(handleValue);
        if (!handle) return '';
        try {
          const base = new URL(config.rootUrl || '/', config.shopUrl || window.location.origin);
          if (base.protocol !== 'https:' || (base.port && base.port !== '443')) return '';
          const prefix = base.pathname.replace(/\/+$/, '');
          const url = new URL(prefix + '/products/' + encodeURIComponent(handle), base.origin);
          const variantId = cleanId(variantValue);
          if (variantId) url.searchParams.set('variant', variantId);
          return url.toString();
        } catch (_error) {
          return '';
        }
      };

      const normalizeProductUrl = (value) => {
        if (!value) return '';
        try {
          const url = new URL(value, config.shopUrl || window.location.origin);
          if (url.protocol !== 'https:' || (url.port && url.port !== '443')) return '';
          if (!allowedProductHosts.has(url.hostname.toLocaleLowerCase())) return '';

          const pathName = url.pathname.replace(/\/+$/, '');
          const rootPath = new URL(config.rootUrl || '/', config.shopUrl || window.location.origin)
            .pathname
            .replace(/\/+$/, '');
          const prefixes = ['/products'];
          if (rootPath) prefixes.push(rootPath + '/products');

          let handle = '';
          for (const prefix of prefixes) {
            if (!pathName.startsWith(prefix + '/')) continue;
            const remainder = pathName.slice(prefix.length + 1);
            if (remainder.includes('/')) continue;
            handle = cleanHandle(remainder);
            if (handle) break;
          }
          if (!handle) return '';

          return buildCanonicalProductUrl(handle, cleanId(url.searchParams.get('variant')));
        } catch (_error) {
          return '';
        }
      };

      const safeImageUrl = (value) => {
        if (!value) return '';
        try {
          const url = new URL(value, window.location.origin);
          if (url.protocol !== 'https:' || (url.port && url.port !== '443')) return '';
          const host = url.hostname.toLocaleLowerCase();
          const trustedCdn = host === 'cdn.shopify.com'
            || host.endsWith('.shopifycdn.com');
          const trustedStoreImage = allowedProductHosts.has(host)
            && url.pathname.startsWith('/cdn/');
          if (!trustedCdn && !trustedStoreImage) return '';
          return url.toString();
        } catch (_error) {
          return '';
        }
      };

      const handleFromProductUrl = (value) => {
        const safeUrl = normalizeProductUrl(value);
        if (!safeUrl) return '';
        try {
          const match = new URL(safeUrl).pathname.match(/\/products\/([a-z0-9][a-z0-9-]*)/i);
          return match ? cleanHandle(match[1]) : '';
        } catch (_error) {
          return '';
        }
      };

      const variantFromProductUrl = (value) => {
        const safeUrl = normalizeProductUrl(value);
        if (!safeUrl) return '';
        try {
          return cleanId(new URL(safeUrl).searchParams.get('variant'));
        } catch (_error) {
          return '';
        }
      };

      const productImage = (product) => {
        const candidate = product && product.featured_image;
        if (typeof candidate === 'string') return safeImageUrl(candidate);
        if (candidate && typeof candidate === 'object') {
          return safeImageUrl(candidate.url || candidate.src);
        }
        if (Array.isArray(product && product.images)) return safeImageUrl(product.images[0]);
        return safeImageUrl(product && product.image);
      };

      const productUrlFromData = (product, handle) => {
        const supplied = normalizeProductUrl(product && product.url);
        if (supplied) return supplied;
        return buildCanonicalProductUrl(handle);
      };

      const chooseVariant = (product, requestedVariantId, requestedSku = '') => {
        const variants = Array.isArray(product && product.variants) ? product.variants : [];
        if (!variants.length) return null;
        if (requestedVariantId) {
          const exact = variants.find((variant) => String(variant.id || '') === String(requestedVariantId));
          return exact || null;
        }
        if (requestedSku) {
          const exact = variants.find((variant) => {
            return cleanText(variant.sku, 120).toLocaleLowerCase() === requestedSku.toLocaleLowerCase();
          });
          return exact || null;
        }
        return variants.find((variant) => variant.available !== false) || variants[0];
      };

      const normalizeProduct = (rawProduct, source, overrides = {}) => {
        const raw = rawProduct || {};
        const requestedVariantId = cleanId(overrides.variantId);
        const explicitSku = cleanText(overrides.sku, 120);
        const suppliedUrl = normalizeProductUrl(overrides.url || raw.url);
        const urlVariantId = variantFromProductUrl(suppliedUrl);
        const effectiveVariantId = requestedVariantId || urlVariantId;
        const variant = chooseVariant(raw, effectiveVariantId, explicitSku);
        const handle = cleanHandle(
          handleFromProductUrl(suppliedUrl)
          || overrides.handle
          || raw.handle
        );
        const title = cleanText(overrides.title || raw.title, 240);
        const sku = explicitSku || cleanText(variant && variant.sku, 120);
        const variantId = effectiveVariantId || cleanId(variant && variant.id);
        const url = buildCanonicalProductUrl(handle, effectiveVariantId)
          || productUrlFromData(raw, handle);
        const productId = cleanId(overrides.productId || raw.id);
        const vendor = cleanText(raw.vendor, 120);
        const productType = cleanText(raw.product_type || raw.type, 120);
        const image = safeImageUrl(overrides.image) || productImage(raw);

        return {
          title,
          sku,
          url,
          handle,
          productId,
          variantId,
          source: cleanText(source, 60),
          vendor,
          productType,
          image,
          available: raw.available !== false,
          variants: Array.isArray(raw.variants) ? raw.variants : []
        };
      };

      let selectedProduct = null;
      let finderHasAttachment = false;
      let autoReferenceValue = '';
      let activityGeneration = 0;
      let searchTimer = 0;
      let searchController = null;
      let prefillController = null;
      let resultProducts = [];
      let activeResultIndex = -1;

      const abortAsyncWork = () => {
        activityGeneration += 1;
        window.clearTimeout(searchTimer);
        if (searchController) searchController.abort();
        if (prefillController) prefillController.abort();
        searchController = null;
        prefillController = null;
        if (searchInput) searchInput.setAttribute('aria-busy', 'false');
      };

      const setFieldValue = (field, value) => {
        if (field) field.value = value || '';
      };

      const setSelectedImage = (url) => {
        if (!selectedThumb) return;
        selectedThumb.replaceChildren();
        if (!url) {
          selectedThumb.textContent = config.strings.fallbackBadge;
          return;
        }
        const image = document.createElement('img');
        image.src = url;
        image.alt = '';
        image.width = 62;
        image.height = 62;
        image.loading = 'lazy';
        image.decoding = 'async';
        selectedThumb.append(image);
      };

      const renderSelectedProduct = (product, options = {}) => {
        selectedProduct = product;
        if (!selectedCard || !product) return;

        finderHasAttachment = true;
        selectedCard.hidden = false;
        if (selectedTitle) {
          selectedTitle.textContent = product.title
            || product.sku
            || product.handle
            || config.strings.fallbackTitle;
        }

        const metaParts = [];
        if (product.sku) metaParts.push(config.strings.skuPrefix + ' ' + product.sku);
        if (product.vendor) metaParts.push(product.vendor);
        if (product.productType) metaParts.push(product.productType);
        if (selectedMeta) {
          selectedMeta.textContent = metaParts.join(' · ') || config.strings.selectedMetaFallback;
        }

        setSelectedImage(product.image);

        if (selectedLink) {
          selectedLink.hidden = !product.url;
          if (product.url) selectedLink.href = product.url;
          else selectedLink.removeAttribute('href');
        }

        setFieldValue(fields.title, product.title);
        setFieldValue(fields.sku, product.sku);
        setFieldValue(fields.url, product.url);
        setFieldValue(fields.handle, product.handle);
        setFieldValue(fields.productId, product.productId);
        setFieldValue(fields.variantId, product.variantId);
        setFieldValue(fields.source, product.source);

        if (
          referenceInput
          && (
            !referenceInput.value.trim()
            || options.forceReference
            || (autoReferenceValue && referenceInput.value === autoReferenceValue)
          )
        ) {
          autoReferenceValue = [product.sku, product.title].filter(Boolean).join(' — ')
            || product.url
            || product.handle
            || '';
          referenceInput.value = autoReferenceValue;
        }

        if (finderState && (!finder || !finder.open)) finderState.textContent = config.strings.attachedState;
        setFinderStatus(config.strings.attachedStatus);
        updateSignal();
      };

      const clearSelectedProduct = (options = {}) => {
        abortAsyncWork();
        selectedProduct = null;
        finderHasAttachment = false;
        if (selectedCard) selectedCard.hidden = true;
        if (selectedTitle) selectedTitle.textContent = '';
        if (selectedMeta) selectedMeta.textContent = '';
        if (selectedLink) {
          selectedLink.hidden = true;
          selectedLink.removeAttribute('href');
        }
        setSelectedImage('');
        Object.values(fields).forEach((field) => setFieldValue(field, ''));
        if (
          referenceInput
          && (
            options.clearReference
            || (autoReferenceValue && referenceInput.value === autoReferenceValue)
          )
        ) {
          referenceInput.value = '';
        }
        autoReferenceValue = '';
        if (finderState) {
          finderState.textContent = finder && finder.open
            ? config.strings.finderClose
            : config.strings.finderOpen;
        }
        setFinderStatus(config.strings.minimum);
        updateSignal();

        if (options.returnFocus) {
          const target = finder ? finder.querySelector('summary') : referenceInput;
          if (target) target.focus();
        }
      };

      const setFinderStatus = (text, state = '') => {
        if (!searchStatus) return;
        searchStatus.textContent = text || '';
        searchStatus.classList.toggle('is-loading', state === 'loading');
        searchStatus.classList.toggle('is-error', state === 'error');
      };

      const setResultsVisible = (visible) => {
        if (searchResults) searchResults.hidden = !visible;
        if (searchInput) {
          searchInput.setAttribute('aria-expanded', visible ? 'true' : 'false');
          if (!visible) searchInput.removeAttribute('aria-activedescendant');
        }
        if (!visible) activeResultIndex = -1;
      };

      const setActiveResult = (index) => {
        if (!searchResults || !searchInput || !resultProducts.length) return;
        const bounded = ((index % resultProducts.length) + resultProducts.length) % resultProducts.length;
        activeResultIndex = bounded;
        const options = Array.from(searchResults.querySelectorAll('[role="option"]'));
        options.forEach((option, optionIndex) => {
          option.setAttribute('aria-selected', optionIndex === bounded ? 'true' : 'false');
        });
        const active = options[bounded];
        if (active) {
          searchInput.setAttribute('aria-activedescendant', active.id);
          active.scrollIntoView({ block: 'nearest' });
        }
      };

      const renderResultImage = (container, product) => {
        const url = productImage(product);
        if (!url) {
          container.textContent = config.strings.fallbackBadge;
          return;
        }
        const image = document.createElement('img');
        image.src = url;
        image.alt = '';
        image.width = 54;
        image.height = 54;
        image.loading = 'lazy';
        image.decoding = 'async';
        container.append(image);
      };

      const attachResult = (rawProduct) => {
        abortAsyncWork();
        const product = normalizeProduct(rawProduct, 'Contact page search');
        renderSelectedProduct(product, { forceReference: true });
        setResultsVisible(false);
        if (searchResults) searchResults.replaceChildren();
        resultProducts = [];
        if (searchInput) searchInput.value = '';
        if (searchReset) searchReset.hidden = true;
        if (finder) finder.open = false;
        if (changeProduct) changeProduct.focus();
      };

      const renderResults = (products) => {
        if (!searchResults) return;
        searchResults.replaceChildren();
        resultProducts = products.slice(0, 8);
        activeResultIndex = -1;

        resultProducts.forEach((product, index) => {
          const option = document.createElement('button');
          option.type = 'button';
          option.id = String(config.sectionId || 'vcc-signal') + '-product-option-' + index;
          option.className = 'vcc-signal-desk__product-result';
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');
          option.tabIndex = -1;

          const thumb = document.createElement('span');
          thumb.className = 'vcc-signal-desk__result-thumb';
          thumb.setAttribute('aria-hidden', 'true');
          renderResultImage(thumb, product);

          const copy = document.createElement('span');
          copy.className = 'vcc-signal-desk__result-copy';
          const title = document.createElement('strong');
          title.textContent = cleanText(product.title, 240) || config.strings.untitledResult;
          const meta = document.createElement('span');
          const variant = chooseVariant(product, '', '');
          const metaParts = [
            cleanText(product.vendor, 120),
            cleanText(product.product_type || product.type, 120),
            cleanText(variant && variant.sku, 120)
          ].filter(Boolean);
          meta.textContent = metaParts.join(' · ') || config.strings.resultMetaFallback;
          copy.append(title, meta);

          const state = document.createElement('span');
          state.className = 'vcc-signal-desk__result-state';
          state.textContent = product.available === false
            ? config.strings.unavailable
            : config.strings.available;

          option.append(thumb, copy, state);
          option.addEventListener('click', () => attachResult(product));
          option.addEventListener('pointerenter', () => setActiveResult(index));
          searchResults.append(option);
        });

        setResultsVisible(resultProducts.length > 0);
      };

      const predictiveEndpoint = (query) => {
        const url = new URL(config.predictiveSearchUrl || '/search/suggest', window.location.origin);
        if (!url.pathname.endsWith('.json')) url.pathname += '.json';
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '8');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][prefix]', 'last');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        url.searchParams.set(
          'resources[options][fields]',
          'title,product_type,vendor,tag,variants.title,variants.sku'
        );
        return url;
      };

      const runProductSearch = async (query, generation) => {
        if (!searchInput || generation !== activityGeneration) return;
        searchController = new AbortController();
        searchInput.setAttribute('aria-busy', 'true');
        setFinderStatus(config.strings.loading, 'loading');

        try {
          const response = await fetch(predictiveEndpoint(query), {
            method: 'GET',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            signal: searchController.signal
          });
          if (!response.ok) throw new Error('lookup_failed');
          const payload = await response.json();
          if (generation !== activityGeneration) return;

          const products = payload
            && payload.resources
            && payload.resources.results
            && Array.isArray(payload.resources.results.products)
            ? payload.resources.results.products
            : [];

          renderResults(products);
          if (products.length) {
            const resultText = products.length === 1
              ? config.strings.resultsOne
              : config.strings.resultsMany;
            setFinderStatus(String(resultText).replace('{count}', String(products.length)));
          } else {
            setFinderStatus(String(config.strings.empty).replace('{query}', query));
          }
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          if (generation !== activityGeneration) return;
          if (searchResults) searchResults.replaceChildren();
          resultProducts = [];
          setResultsVisible(false);
          setFinderStatus(config.strings.error, 'error');
        } finally {
          if (generation === activityGeneration) {
            searchInput.setAttribute('aria-busy', 'false');
          }
        }
      };

      const handleSearchInput = () => {
        abortAsyncWork();
        const query = searchInput.value.trim();
        if (searchReset) searchReset.hidden = query.length === 0;
        if (searchResults) searchResults.replaceChildren();
        resultProducts = [];
        setResultsVisible(false);
        searchInput.setAttribute('aria-busy', 'false');

        if (query.length < 2) {
          setFinderStatus(config.strings.minimum);
          return;
        }

        const generation = activityGeneration;
        searchTimer = window.setTimeout(() => runProductSearch(query, generation), 220);
      };

      listen(searchInput, 'input', handleSearchInput);
      listen(referenceInput, 'input', () => {
        if (autoReferenceValue && referenceInput.value !== autoReferenceValue) autoReferenceValue = '';
      });
      listen(searchInput, 'keydown', (event) => {
        if (event.isComposing) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          abortAsyncWork();
          if (searchResults) searchResults.replaceChildren();
          resultProducts = [];
          setResultsVisible(false);
          setFinderStatus(
            finderHasAttachment ? config.strings.attachedStatus : config.strings.minimum
          );
          return;
        }

        if (!resultProducts.length || !searchResults || searchResults.hidden) {
          if (event.key === 'Enter') event.preventDefault();
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActiveResult(activeResultIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActiveResult(activeResultIndex < 0 ? resultProducts.length - 1 : activeResultIndex - 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          setActiveResult(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          setActiveResult(resultProducts.length - 1);
        } else if (event.key === 'Enter') {
          event.preventDefault();
          if (activeResultIndex >= 0) attachResult(resultProducts[activeResultIndex]);
        }
      });

      listen(searchReset, 'click', () => {
        if (!searchInput) return;
        searchInput.value = '';
        handleSearchInput();
        searchInput.focus();
      });

      listen(finder, 'toggle', () => {
        if (finderState) {
          if (finder.open) finderState.textContent = config.strings.finderClose;
          else if (finderHasAttachment) finderState.textContent = config.strings.attachedState;
          else finderState.textContent = config.strings.finderOpen;
        }
        if (!finder.open) {
          abortAsyncWork();
          if (searchResults) searchResults.replaceChildren();
          resultProducts = [];
          setResultsVisible(false);
          if (searchInput) searchInput.value = '';
          if (searchReset) searchReset.hidden = true;
          setFinderStatus(
            finderHasAttachment ? config.strings.attachedStatus : config.strings.minimum
          );
        }
      });

      const openFinder = () => {
        if (!finder) return;
        const parentPanel = finder.closest('.vcc-signal-desk__panel');
        if (parentPanel instanceof HTMLDetailsElement) parentPanel.open = true;
        finder.open = true;
        finder.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
        window.requestAnimationFrame(() => {
          if (searchInput) searchInput.focus();
        });
      };

      listen(changeProduct, 'click', openFinder);
      root.querySelectorAll('[data-vcc-open-finder]').forEach((button) => listen(button, 'click', openFinder));
      listen(removeProduct, 'click', () => clearSelectedProduct({ returnFocus: true }));

      root.querySelectorAll('[data-vcc-open-target]').forEach((link) => {
        listen(link, 'click', (event) => {
          const selector = link.getAttribute('data-vcc-open-target');
          const target = selector ? root.querySelector(selector) : null;
          if (!target) return;
          event.preventDefault();
          if (target instanceof HTMLDetailsElement) target.open = true;
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          window.requestAnimationFrame(() => {
            const focusTarget = target.querySelector('[data-vcc-anchor-focus], summary');
            if (focusTarget) focusTarget.focus();
          });
        });
      });

      const responsiveDetails = Array.from(root.querySelectorAll('[data-vcc-responsive-details]'));
      const desktopQuery = window.matchMedia('(min-width: 750px)');
      const syncResponsiveDetails = () => {
        responsiveDetails.forEach((details) => {
          details.open = desktopQuery.matches;
        });
      };
      syncResponsiveDetails();
      if (typeof desktopQuery.addEventListener === 'function') {
        listen(desktopQuery, 'change', syncResponsiveDetails);
      } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(syncResponsiveDetails);
        cleanupTasks.push(() => desktopQuery.removeListener(syncResponsiveDetails));
      }

      const updateHeaderOffset = () => {
        const stickyHeader = document.querySelector('[data-vcc-header].vcc-main-header--sticky');
        if (!stickyHeader) {
          root.style.setProperty('--vcc-sd-header-offset', '0px');
          return;
        }
        const style = window.getComputedStyle(stickyHeader);
        const sticky = style.position === 'sticky' || style.position === 'fixed';
        const rect = stickyHeader.getBoundingClientRect();
        const offset = sticky && rect.bottom > 0 ? Math.max(0, rect.height) : 0;
        root.style.setProperty('--vcc-sd-header-offset', Math.round(offset) + 'px');
      };
      updateHeaderOffset();
      listen(window, 'resize', updateHeaderOffset, { passive: true });

      let headerObserver = null;
      const observedHeader = document.querySelector('[data-vcc-header]');
      if (observedHeader && typeof ResizeObserver === 'function') {
        headerObserver = new ResizeObserver(updateHeaderOffset);
        headerObserver.observe(observedHeader);
        cleanupTasks.push(() => headerObserver.disconnect());
      }

      const postedProduct = {
        title: cleanText(fields.title && fields.title.value, 240),
        sku: cleanText(fields.sku && fields.sku.value, 120),
        url: normalizeProductUrl(fields.url && fields.url.value),
        handle: cleanHandle(fields.handle && fields.handle.value),
        productId: cleanId(fields.productId && fields.productId.value),
        variantId: cleanId(fields.variantId && fields.variantId.value)
      };
      const hasPostedProduct = [
        postedProduct.title,
        postedProduct.sku,
        postedProduct.url,
        postedProduct.handle,
        postedProduct.productId,
        postedProduct.variantId
      ].some(Boolean);
      if (hasPostedProduct) {
        renderSelectedProduct(
          normalizeProduct(
            {},
            cleanText(fields.source && fields.source.value, 60) || 'Contact form retry',
            postedProduct
          )
        );
      }

      const parameters = new URLSearchParams(window.location.search);
      const requestedTopic = cleanText(parameters.get('topic'), 120);
      const requestedTopicApplied = !feedback && requestedTopic
        ? setTopic(requestedTopic, { markTouched: false })
        : false;

      const explicit = {
        title: cleanText(parameters.get('product_title'), 240),
        sku: cleanText(parameters.get('product_sku'), 120),
        url: normalizeProductUrl(parameters.get('product_url')),
        handle: cleanHandle(parameters.get('product_handle')),
        productId: cleanId(parameters.get('product_id')),
        variantId: cleanId(parameters.get('variant_id')),
        image: safeImageUrl(parameters.get('product_image'))
      };
      const explicitUrlHandle = handleFromProductUrl(explicit.url);
      const explicitUrlVariant = variantFromProductUrl(explicit.url);
      if (explicitUrlHandle) explicit.handle = explicitUrlHandle;
      if (!explicit.variantId && explicitUrlVariant) explicit.variantId = explicitUrlVariant;
      if (explicit.handle) {
        explicit.url = buildCanonicalProductUrl(explicit.handle, explicit.variantId);
      }

      const hasProductPrefill = [
        explicit.title,
        explicit.sku,
        explicit.url,
        explicit.handle,
        explicit.productId,
        explicit.variantId
      ].some(Boolean);
      if (hasProductPrefill && !hasPostedProduct) {
        const synchronousProduct = normalizeProduct({}, 'Product page button', explicit);
        renderSelectedProduct(synchronousProduct);

        if (explicit.handle) {
          const prefillGeneration = activityGeneration;
          prefillController = new AbortController();

          try {
            const base = new URL(config.rootUrl || '/', window.location.origin);
            const prefix = base.pathname.replace(/\/$/, '');
            const productEndpoint = new URL(
              prefix + '/products/' + encodeURIComponent(explicit.handle) + '.js',
              base.origin
            );

            fetch(productEndpoint, {
              method: 'GET',
              credentials: 'same-origin',
              headers: { Accept: 'application/json' },
              signal: prefillController.signal
            })
              .then((response) => {
                if (!response.ok) throw new Error('product_enrichment_failed');
                return response.json();
              })
              .then((product) => {
                if (prefillGeneration !== activityGeneration) return;
                const enriched = normalizeProduct(product, 'Product page button', {
                  title: explicit.title || product.title,
                  sku: explicit.sku,
                  url: explicit.url || product.url,
                  handle: explicit.handle,
                  productId: explicit.productId || product.id,
                  variantId: explicit.variantId,
                  image: explicit.image
                });
                renderSelectedProduct(enriched);
              })
              .catch(() => {
                /* The synchronous URL prefill remains usable when enrichment is unavailable. */
              });
          } catch (_error) {
            /* The synchronous URL prefill remains usable when enrichment is unavailable. */
          }
        }

        if (!feedback && !requestedTopicApplied && !topicTouched) {
          setTopic('product-details', { markTouched: false });
        }
      }

      if (feedback) {
        window.requestAnimationFrame(() => feedback.focus());
      }

      root.vccSignalDeskCleanup = () => {
        abortAsyncWork();
        cleanupTasks.splice(0).forEach((task) => task());
        delete root.vccSignalDeskCleanup;
        delete root.dataset.vccSignalReady;
      };
    };

    const initializeAll = (scope = document) => {
      if (scope.matches && scope.matches(rootSelector)) initialize(scope);
      scope.querySelectorAll(rootSelector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches && event.target.matches(rootSelector)
        ? event.target
        : event.target.querySelector(rootSelector);
      if (root && typeof root.vccSignalDeskCleanup === 'function') root.vccSignalDeskCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
